import { IonButtons, IonCol, IonContent, IonBackButton, IonGrid
  , IonHeader, IonItem, IonLabel, IonMenuButton
  , IonPage, IonRow, IonTitle, IonToolbar, IonDatetime, IonList 
  , IonModal, IonButton, IonText, IonSpinner, IonIcon, IonAlert, IonDatetimeButton} from '@ionic/react';

import React, { useEffect, useState, useRef } from 'react';
import { chevronForward } from 'ionicons/icons';
import './Bams.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import { useParams } from 'react-router';
import { calendarOutline, chevronForwardOutline } from 'ionicons/icons';
import ServerService from '../../../services/Server';
import { array } from 'yup';
type ConFormParams = {
  id:string, 
  dummy:string
}

const BamsForm: React.FC = () => {

 const {id, dummy} = useParams<ConFormParams>();
 const server = new ServerService();
 const name:string = "History";
 
 const today = new Date().toISOString();
 const [startDate, setStartDate] = useState<string>(today);
 const [endDate, setEndDate] = useState<string>(today);
 const [listHistory, setListHistory] = useState<any[]>([]);
 const isFirstRender = useRef(true);

 const [showDetailModal, setShowDetailModal] = useState(false);
const [selectedItem, setSelectedItem] = useState<any>(null);
const state = server.state;
 const fetchData = (start: string, end: string) => {
  console.log("กำลังดึงข้อมูลระหว่าง:", start, "ถึง", end);
  //2026-01-31T17:00:00.000Z
  const data = {
    alf_ticket : state.ticket, 
    start : start,
    end : end
  }
  fetch(server.getFullUrl("bams/listHistory", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {
      if(!result.success){
        return false;
      }else{
        setListHistory(result.data);
      }
    },
    (error) => {

    }
 ).catch(e => {

 })
).catch(e => {
}) 

 
  //setHistoryData(filtered);
};
useEffect(() => {
  
  if (startDate && endDate) {
    fetchData(startDate, endDate);
  }
}, [startDate, endDate]); // ทำงานทุกครั้งที่วันที่ใดวันที่หนึ่งเปลี่ยน

useEffect(() => {
    //fetchData(startDate, endDate);
}, []);

 const getDayColor = (dayAbbr: string) => {
  switch (dayAbbr) {
    case 'อา.': return '#FF3B30'; // แดง
    case 'จ.': return '#FFCC00';  // เหลือง
    case 'อ.': return '#FF2D55';  // ชมพู
    case 'พ.': return '#34C759';  // เขียว
    case 'พฤ.': return '#FF9500'; // ส้ม
    case 'ศ.': return '#5856D6';  // ฟ้า/น้ำเงิน
    case 'ส.': return '#AF52DE';  // ม่วง
    case 'Sun': return '#FF3B30'; // แดง
    case 'Mon': return '#FFCC00';  // เหลือง
    case 'Tue': return '#FF2D55';  // ชมพู
    case 'Wed': return '#34C759';  // เขียว
    case 'Thu': return '#FF9500'; // ส้ม
    case 'Fri': return '#5856D6';  // ฟ้า/น้ำเงิน
    case 'Sat': return '#AF52DE';  // ม่วง
    default: return '#f0f0f0';
  }
};
/*const sampleDate = [
  { day: 'จ.', date: '16 ก.พ. 69', in: '08:00', out: '17:05' },
  { day: 'อา.', date: '15 ก.พ. 69', in: '08:10', out: '17:00' },
  { day: 'ส.', date: '14 ก.พ. 69', in: '08:30', out: '12:00' },
  { day: 'ศ.', date: '13 ก.พ. 69', in: '07:55', out: '17:10' },
];*/

return (
  <IonPage>
    {/*className="ion-no-border"*/}
    <IonHeader className="blue-header">
      <IonToolbar color="primary">
        <IonButtons slot="start">
          <IonBackButton defaultHref="/page/home/bams" />
        </IonButtons>
        <IonTitle style={{ fontWeight: 'bold' }}>ประวัติการลงเวลา</IonTitle>
      </IonToolbar>
    </IonHeader>

    <IonContent className="ion-padding gray-bg">
     
      <div style={{ background: 'white', borderRadius: '15px', padding: '15px', marginBottom: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
        <IonGrid className="ion-no-padding">
          <IonRow className="ion-align-items-center">
            <IonCol size="5">
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                <IonIcon icon={calendarOutline} style={{ marginRight: '5px', fontSize: '1rem' }} color="primary" />
                <IonLabel color="medium" style={{ fontSize: '0.8rem' }}>วันที่เริ่ม</IonLabel>
              </div>
              <IonDatetimeButton datetime="startDate" />
            </IonCol>
            
            <IonCol size="2" style={{ textAlign: 'center', paddingTop: '20px' }}>
              <IonText color="medium">ถึง</IonText>
            </IonCol>

            <IonCol size="5">
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                <IonIcon icon={calendarOutline} style={{ marginRight: '5px', fontSize: '1rem' }} color="primary" />
                <IonLabel color="medium" style={{ fontSize: '0.8rem' }}>วันที่สิ้นสุด</IonLabel>
              </div>
              <IonDatetimeButton datetime="endDate" />
            </IonCol>
          </IonRow>
        </IonGrid>

       
        <IonModal keepContentsMounted={true}>
          <IonDatetime id="startDate" presentation="date" preferWheel={true} locale="th-TH" onIonChange={e => setStartDate(e.detail.value as string)}/>
        </IonModal>
        <IonModal keepContentsMounted={true}>
          <IonDatetime id="endDate" presentation="date" preferWheel={true} locale="th-TH" onIonChange={e => setEndDate(e.detail.value as string)}/>
        </IonModal>
      </div>

    
      <IonLabel style={{ marginLeft: '10px', fontWeight: 'bold', fontSize: '1.1rem' }}>
        รายละเอียดการลงเวลา
      </IonLabel>

      <IonList lines="none" style={{ background: 'transparent', marginTop: '10px' }}>
        {listHistory.map((item, index) => (
          <div key={index} style={{ 
            background: 'white', 
            borderRadius: '12px', 
            marginBottom: '10px', 
            padding: '12px',
            display: 'flex',
            alignItems: 'center',
            boxShadow: '0 2px 5px rgba(0,0,0,0.03)'
          }}
          onClick={() => {
            setSelectedItem(item);
            setShowDetailModal(true);
          }}>
           
            <div style={{ 
              width: '40px', 
              height: '40px', 
              borderRadius: '50%', 
              background: getDayColor(item.dayEN),
              color: item.dayEN === 'Mon' || item.dayEN === 'Wed' ? 'black' : 'white', // ปรับสีตัวอักษรให้ตัดกับพื้นหลัง
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: '0.9rem',
              marginRight: '12px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}
            >
              {item.dayTH}
            </div>

            <div style={{ flex: 1 }}>
              <IonText style={{ fontSize: '1rem', fontWeight: 'bold' }}>{item.date}</IonText>
              <div style={{ display: 'flex', marginTop: '3px', fontSize: '0.85rem' }}>
                <IonText color="success" style={{ marginRight: '12px' }}>● เข้า: {item.in}</IonText>
                <IonText color="danger">● ออก: {item.out}</IonText>
              </div>
            </div>
            
            <IonIcon icon={chevronForwardOutline} color="medium" />
          </div>
        ))}
      </IonList>
    </IonContent>

    <IonModal isOpen={showDetailModal} onDidDismiss={() => setShowDetailModal(false)}>
  <IonHeader className="ion-no-border">
    <IonToolbar color="light">
      <IonTitle>รายละเอียดการลงเวลา</IonTitle>
      <IonButtons slot="end">
        <IonButton onClick={() => setShowDetailModal(false)}>ปิด</IonButton>
      </IonButtons>
    </IonToolbar>
  </IonHeader>

  <IonContent className="ion-padding gray-bg">
    {selectedItem && (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        
       
        <div style={{ background: 'white', borderRadius: '15px', padding: '15px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <div style={{ width: '12px', height: '12px', borderRadius: '50%', background: '#2dd36f', marginRight: '10px' }}></div>
            <IonText color="dark"><b>ข้อมูลลงเวลาเข้างาน</b></IonText>
          </div>
          
          <div style={{ paddingLeft: '22px' }}>
            <IonText color="medium" style={{ fontSize: '0.9rem' }}>วันที่: {selectedItem.date}</IonText><br />
            <IonText color="success" style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>เวลา: {selectedItem.in} น.</IonText>
            
            <p style={{ fontSize: '0.85rem', color: '#666', marginTop: '10px' }}>
              📍 <b>สถานที่:</b> {selectedItem.address_in || ""}
            </p>
          </div>

         
          <div style={{ width: '100%', height: '150px', background: '#e0e0e0', borderRadius: '10px', marginTop: '10px', overflow: 'hidden' }}>
             
             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: '#999' }}>
             <iframe
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: 0 }}
              src={`https://maps.google.com/maps?q=${selectedItem.geoin}&z=15&output=embed`}
              allowFullScreen
              ></iframe>
             </div>
          </div>
        </div>

        
        <div hidden={selectedItem.geoout==''} style={{ background: 'white', borderRadius: '15px', padding: '15px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <div style={{ width: '12px', height: '12px', borderRadius: '50%', background: '#eb445a', marginRight: '10px' }}></div>
            <IonText color="dark"><b>ข้อมูลลงเวลาออกงาน</b></IonText>
          </div>
          
          <div style={{ paddingLeft: '22px' }}>
            <IonText color="medium" style={{ fontSize: '0.9rem' }}>วันที่: {selectedItem.date}</IonText><br />
            <IonText color="danger" style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>เวลา: {selectedItem.out} น.</IonText>
            
            <p style={{ fontSize: '0.85rem', color: '#666', marginTop: '10px' }}>
              📍 <b>สถานที่:</b> {selectedItem.address_out || ""}
            </p>
          </div>

         
          <div hidden={selectedItem.geoout==''} style={{ width: '100%', height: '150px', background: '#e0e0e0', borderRadius: '10px', marginTop: '10px', overflow: 'hidden' }}>
             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: '#999' }}>
             <iframe
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: 0 }}
              src={`https://maps.google.com/maps?q=${selectedItem.geoout}&z=15&output=embed`}
              allowFullScreen
              ></iframe>
             </div>
          </div>
        </div>

      </div>
    )}
  </IonContent>
</IonModal>

  </IonPage>
);
};

export default BamsForm;
